import { Component, Input, isDevMode } from '@angular/core';
import { environment } from '../../../../src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'aims-spinner',
  styleUrls: ['./spinner.component.css'],
  template: `
            <div *ngIf="ssSubj|async" class="modal fade in" id="spinnerComponent" tabindex="-1" role="dialog" aria-labelledby="Spinner" data-backdrop="static" style="display:block">
                <div class="modal-dialog centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body">
                            <img src="{{spinnerSrc}}/spinner.gif" /><br/>
                            <div class="text-center">{{spinnerText}}</div>
                        </div>
                    </div>
                </div>
            </div>
    `
})

export class SpinnerComponent {
  @Input() spinnerText: string;
  @Input('showSpinner')
  set showSpinner(show: boolean){
      this.ssSubj.next(show);
  }

  ssSubj: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor() {
  }

  spinnerSrc: string = environment.assetsPath;

}
